import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Eye, Lock } from "lucide-react";

/**
 * DemoModeDialog - Global popup shown when an Exposition (visual-only) user
 * attempts any modification (create/edit/save/delete/import/export/upload).
 * It listens for the window "demo-mode-block" event dispatched by the API layer.
 */
export const DemoModeDialog = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = () => setOpen(true);
    window.addEventListener("demo-mode-block", handler);
    return () => window.removeEventListener("demo-mode-block", handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="max-w-sm" data-testid="demo-mode-dialog">
        <DialogHeader>
          <div className="mx-auto mb-3 flex h-14 w-14 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
            <Lock className="h-7 w-7 text-amber-600" />
          </div>
          <DialogTitle className="text-center font-['Outfit'] text-[#0f172a] dark:text-white">
            Demo Mode — Visual Only
          </DialogTitle>
        </DialogHeader>
        <p className="text-center text-sm text-[#64748b] dark:text-slate-300 px-2">
          You are in <span className="font-semibold">Exposition (Demo) Mode</span>. You can explore the entire system,
          but editing, saving, deleting, importing and exporting are disabled.
          <br />
          Please contact your administrator for full access.
        </p>
        <DialogFooter>
          <Button
            className="w-full bg-[#d4af37] hover:bg-[#b5952f] text-[#0f172a]"
            onClick={() => setOpen(false)}
            data-testid="demo-mode-dialog-close"
          >
            <Eye size={16} className="mr-2" />
            Continue Exploring
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DemoModeDialog;
